import * as React from 'react';
import { mergeReactProps } from './mergeReactProps';
export function evaluateRenderProp(render, props, ownerState) {
  return typeof render === 'function' ? render(props, ownerState) : /*#__PURE__*/React.cloneElement(render, mergeReactProps(render.props, props));
}